// extracted by mini-css-extract-plugin
export default {"serviceFeesBadge":"ServiceFeeBadge__serviceFeesBadge-NTM2"};